import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'
import { withTranslation } from 'react-i18next'

import { Row, Col } from 'antd'

import { Banner, NotFound, QuillContent } from '@client/components/index'
import { AppContainer } from '@client/containers/index'
import actions from '@client/actions'

import quillStyles from '@client/styles/quill.styl'

const mapStateToProps = (state) => {
  return {
    story: state.story.data,
    done: state.story.done,
    loadingStatus: state.story.loadingStatus,
  }
}

const mapDispatchToProps = (dispatch) => {
  return { actions: bindActionCreators(actions, dispatch) }
}

const colProps = { xs: 24, md: 20 }

class Story extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    story: PropTypes.object.isRequired,
    done: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
  }

  static defaultProps = {}

  componentDidMount() {
    this.props.actions.getStory(this.props.match.params.storyId)
  }

  render() {
    const { story, done, t } = this.props

    if (done && !story.id) return <NotFound />

    return (
      <AppContainer style={{ paddingTop: 0 }}>
        <Helmet>
          <title>{story.title ? `${story.title} | ${t('浪人故事')}` : t('浪人故事')}</title>
        </Helmet>
        <>
          <Banner backgroundImage={story.cover} logoFlex="center" />
          <Row type="flex" justify="center">
            <Col {...colProps}>
              <h1 className={quillStyles.title}>{story.title}</h1>
            </Col>
            <Col {...colProps}>
              <QuillContent content={story.content} />
            </Col>
          </Row>
        </>
      </AppContainer>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Story))
